module Meevo.Components.Common {
  
  export class PostalCode implements IPostalCode {
    city: string;
    province: string;
    state: string;
    postalCode: string;
  }

  export class PostalCodeService implements IPostalCodeService {
    constructor(private dataService: ICommonDataService) {
      
    }

    codeResult: PostalCode;

    lookupPostalCode(request: any): angular.IPromise<any> {
      return this.dataService.getPostalCodeInfo(request);
    }

    getStates(request: any): angular.IPromise<any> {
      return this.dataService.customMethodData("api/PostalCodeStates", "POST", request);
    }

    static factory(): Function {
      let svc = (dataService: ICommonDataService) => {
        return new PostalCodeService(dataService);
      }

      svc.$inject = ["meevo.components.common.DataService"];

      return svc;
    }
  }

  angular.module("meevo.components.common")
    .factory("meevo.components.common.PostalCodeService", PostalCodeService.factory());
}